module.exports = __webpack_public_path__ + "static/media/documentList.50d1193e.svg";